module.exports = __webpack_public_path__ + "img/icon-2-f6638fc3.svg";